import axios, { getSupplyUnitList, getProvinceList, getChildAddress, getFloor, getAddrestLabel, getOrderType, getOrderTypesBySupplyUnit, getTelegraphicBusiness, getTelegraphicBank, getBankInfo, getOrderPersonList } from '../../API/index';
import { getDictData, getRemittanceConfig } from '@/API/international';
const state = {
  orderProcessType: [], // 订单流程分类
  orderType: [], // 订单分类 特价 非特价
  supplyUnit: [], // 供货单位
  hideCompony: ['RQD113279', 'RQD11562'], // 屏蔽单位
  allAuth: ['R00070', 'R01888'],
  // 控制电汇"修改客户"权限， 彭凯迪 R10444，王媛 R15228，冶倩 R11665，庾辰睿 R23774，彭超 R19806，原怡 R12418，江俊寿R02400.林锦茵R16877
  telegraphicTransferAuth: ['R10444', 'R15228', 'R11665', 'R23774', 'R19806', 'R12418', 'R02400', 'R16877'],
  shipType: [{ code: 1, name: '齐套发货' }, { code: 2, name: '分批发货' }],
  internationalShipType: [{ code: 1, name: '齐套发货' }, { code: 2, name: '分批发货' }],
  freightProperty: {
    '10': '直发',
    '20': '不发货有回执',
    '40': '不发货无回执',
    '50': '供应商直发',
    '60': '软件订单'
  },
  CityList: [],
  floor: [],
  addressLabel: [],
  deliveryTime: [{ code: 0, name: '只工作日送货' }, { code: 1, name: '工作日和周末都可以送货' }],
  meteringPoint: [{ code: 1, name: '计量计点' }, { code: 2, name: '计量不计点' }, { code: 3, name: '不计量不计点' }],
  salesType: [{ code: 1, name: '现销' }, { code: 2, name: '赊销' }],
  internationalSalesType: [{ code: 1, name: '现销' }, { code: 2, name: '赊销' }, { code: 3, name: 'LC' }],
  isEmbeddedSoftware: [{ code: false, name: '不体现' }, { code: true, name: '体现' }],
  EmbeddedSoftware: [{ code: false, name: '否' }, { code: true, name: '是' }],
  contracStatus: ['已完成', '待提交', '待盖章', '待付款', '分配完成'], // 合同状态
  LogisticsStatus: ['暂无结果', '已揽件', '在途中', '派件中', '已签收', '疑难', '退签', '退回'], // 物流信息状态
  contratOrderType: [],
  contratOrderState: [{ code: '1', name: '新建订单合同' }, { code: '2', name: '服务订单' }],
  moneyType: [{ code: 'CNY', name: '人民币' }, { code: 'HKD', name: '港币' }, { code: 'USD', name: '美元' }, { code: 'JPY', name: '日元' }],
  paymentMethod: ['立即付款'],
  shanghaiHongkongDiscount: [0.5, 0.6, 0.7, 0.8, 0.9, 0.95, 1.0],
  interShanghaiHongkongDiscount: [0.8, 0.9, 1.0],
  businessNameList: [],
  importCompanyList: [],
  getBankInfoList: [],
  atAfterSight: ['', '即期', '远期'],
  mounth: [{ code: '1', name: '1月' }, { code: '2', name: '2月' }, { code: '3', name: '3月' }, { code: '4', name: '4月' }, { code: '5', name: '5月' }, { code: '6', name: '6月' }, { code: '7', name: '7月' }, { code: '8', name: '8月' }, { code: '9', name: '9月' }, { code: '10', name: '10月' }, { code: '11', name: '11月' }, { code: '12', name: '12月' }],
  year: [{ code: '2022', name: '2022' }],
  salesTypeList: [{ code: '', name: '全部' }, { code: '1', name: '现销' }, { code: '2', name: '赊销' }, { code: '3', name: 'LC' }],
  postStatus: [{ code: '', name: '全部' }, { code: '1', name: '是' }, { code: '0', name: '否' }],
  contractStatus: [{ code: '1', name: '待提交' }, { code: '2', name: '待盖章' }, { code: '3', name: '待付款' }, { code: '5', name: '待订单员发布' }, { code: '6', name: '订单员已发布' }],
  isOrderAutoList: [{ code: '', name: '全部' }, { code: true, name: '是' }, { code: false, name: '否' }],
  contractType: [{ code: '', name: '全部' }, { code: 'SMB分销下单', name: 'SMB分销下单' }, { code: '服务商分销下单', name: '服务商分销下单' }, { code: '特价下单', name: '特价下单' }, { code: '固定折扣下单', name: '固定折扣下单' }, { code: '非特价下单', name: '非特价下单' }, { code: '服务订单', name: '服务订单' }, { code: '价外费用', name: '价外费用' }, { code: '销售借用下单', name: '销售借用下单' }, { code: '国际业务下单', name: '国际业务下单' }, { code: '国际分销下单', name: '国际分销下单' }, { code: '国际备件下单', name: '国际备件下单' }],
  successfulSpinSelect: [{ code: '0', name: '是', success: true }, { code: '1', name: '否', success: false }], // 关务已审批发货单列表,是否抛转成功搜索条件
  orderPersonList: [],
  remittanceScenarioOptions: [], // 付款用途
  remittanceWay: [], // 付款方式
  remittanceType: [], // 汇款类型
  remittanceScenarioOptionsCN: [], // 汇款类型CN
  changeType: [], // 客期变更类型下拉数据
  changeAdvance: [], // 客期变更场景提前下拉数据
  changeDelay: [], // 客期变更场景延迟下拉数据
  changeStatus: [] // 客期变更场景延迟下拉数据
};
const mutations = {};
const getters = {
  getmeteringPoint: (state) => (code) => {
    let name;
    if (code) {
      let newCode = Number(code);
      state.meteringPoint.forEach((item) => {
        if (newCode === item.code) {
          name = item.name;
        }
      });
    }
    return name;
  },
  getisEmbeddedSoftware: (state) => (code) => {
    if (code !== undefined) {
      let name = '';
      state.isEmbeddedSoftware.forEach((item) => {
        if (item.code === code) {
          name = item.name;
        }
      });
      return name;
    }
  },
  getsalesType: (state) => (code) => {
    let name;
    if (code) {
      let newCode = Number(code);
      state.salesType.forEach((item) => {
        if (newCode === item.code) {
          name = item.name;
        }
      });
    }
    return name;
  }
};
const actions = {
  initOrderProcessType ({ commit, state }) {
    // 初始化订单流程分类枚举值
    if (!state.orderProcessType.length) {
    }
  },
  initremittance ({ commit, state }) {
    if (!state.remittanceScenarioOptions.length) {
      axios.all([
        getRemittanceConfig(0),
        getRemittanceConfig(1),
        getRemittanceConfig(2),
        getRemittanceConfig(3)

      ]).then((res) => {
        const data1 = res[0].data;
        const data2 = res[1].data;
        const data3 = res[2].data;
        const data4 = res[3].data;
        if (data1.status === '200') {
          state.remittanceWay = data1.data;
        }
        if (data2.status === '200') {
          state.remittanceScenarioOptions = data2.data;
        }
        if (data3.status === '200') {
          state.remittanceType = data3.data;
        }
        if (data4.status === '200') {
          state.remittanceScenarioOptionsCN = data4.data;
        }
      });
    }
  },
  initOrderType ({ commit, state }) {
    // 初始化订单分类枚举值
    if (!state.orderType.length) {
      getOrderType().then((res) => {
        let json = res.data;
        let list = [];
        if (json.status === '200') {
          let Type = JSON.parse(json.data);
          Type.forEach((item) => {
            let map = {
              code: item.key,
              name: item.key
            };
            list.push(map);
          });
        }
        state.orderType = list;
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initSupplyUnit ({ commit, state }) {
    // 初始化供货单位
    if (!state.supplyUnit.length) {
      getSupplyUnitList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let list = [];
          json.data.forEach((item) => {
            let map = {
              code: item.supplyCode,
              id: item.id,
              name: item.supplyUnit,
              supplyAddress: item.supplyAddress,
              supplyPhone: item.supplyPhone,
              unitAbbreviation: item.unitAbbreviation
            };
            list.push(map);
          });
          state.supplyUnit = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },

  initCityList ({ commit, state }) {
    //
    if (!state.CityList.length) {
      getProvinceList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          state.CityList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initFloor ({ commit, state }) {
    if (!state.floor.length) {
      getFloor().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let floors = JSON.parse(json.data);
          let list = [];
          floors.forEach((item) => {
            list.push({
              code: Object.keys(item)[0],
              name: Object.values(item)[0]
            });
          });
          state.floor = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initContratOrderType ({ commit, state }) {
    if (!state.contratOrderType.length) {
      getOrderTypesBySupplyUnit().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let list = [];
          json.data.forEach((item) => {
            let map = {
              code: item.basicInfoID,
              name: item.basicInfoName
            };
            list.push(map);
          });
          state.contratOrderType = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initAddressLabel ({ commit, state }) {
    if (!state.addressLabel.length) {
      getAddrestLabel().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let floors = JSON.parse(json.data);
          let list = [];
          floors.forEach((item) => {
            list.push({
              code: Object.keys(item)[0],
              name: Object.values(item)[0]
            });
          });
          state.addressLabel = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  getProvinceListByNode ({ commit, state }, { node, resolve }) {
    // 根据每个节点 异步加载下属区县
    console.log(node, '查看node参数', resolve);
    let parmas = {
      parentName: node.data.code, level: node.data.level
    };
    if (!node.children.length) {
      getChildAddress(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.length) {
            let level = json.data[0].level;
            if (level === 'COUNTRY') {
              json.data.forEach((item) => {
                item.leaf = true;
              });
            }
          }
          resolve(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initBusinessNameList ({ commit, state }) {
    if (!state.businessNameList.length) {
      getTelegraphicBusiness().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let floors = JSON.parse(json.data);
          let list = [];
          floors.forEach((item) => {
            list.push({
              code: Object.keys(item)[0],
              name: Object.values(item)[0]
            });
          });
          console.log(list);
          state.businessNameList = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initImportCompanyList ({ commit, state }) {
    if (!state.importCompanyList.length) {
      getTelegraphicBank().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let floors = JSON.parse(json.data);
          let list = [];
          floors.forEach((item) => {
            list.push({
              code: Object.keys(item)[0],
              name: Object.values(item)[0]
            });
          });
          state.importCompanyList = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  getBankInfo ({ commit, state }) {
    if (!state.getBankInfoList.length) {
      getBankInfo().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          state.getBankInfoList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  initOrderPersonlist ({ commit, state }) {
    if (!state.orderPersonList.length) {
      getOrderPersonList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          state.orderPersonList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  // 获取客期变更下拉信息
  GET_CODE_CHANGE ({ commit, state }, { type, dictType }) {
    getDictData({ dictType }).then((res) => {
      let json = res.data;
      if (json.status === '200') {
        if (json.data && json.data.length > 0) {
          state[type] = json.data.map(({ dictLabel: label, dictValue: value }) => ({ label, value }));
        }
      }
    }).catch((e) => {
      console.log(e);
    });
  }
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
